import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';

import './twoPage4.scss';

function TwoPage4(props) {
  const {setCurrentPage, currentFooter} = props;
  console.log('currentFooter: ', currentFooter);

  return (
    <>
      <div className="growth-page growth-page--4">
        <div className="growth-page__row">
          <h1 className="growth-page__title _title _growth-anim">Участник площадки &mdash;&nbsp;вся страна</h1>
        </div>
        <div className="growth-page__row growth-page__row--1">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Октябрь</span>
            <span className="growth-page__year">2015</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">
            Доставка покупок с&nbsp;&laquo;Авито&raquo; по&nbsp;всей стране
          </h2>
        </div>
        <div className="growth-page__row growth-page__row--2">
          <div className="growth-page__col">
            <div className="growth-page__wrap-img">
              <div className="growth-page__img _growth-anim">
                <img
                  src="img/two/growth-page-4-1.png"
                  srcSet="img/two/growth-page-4-1.png 1x, img/two/growth-page-4-1@2x.png 2x"
                  alt="img"
                  className="_growth-anim"
                />
              </div>
              <p className="growth-page__caption _growth-anim _growth-anim--fade">
                &laquo;Avito самый быстрорастущий сервис объявлений в&nbsp;мире&raquo;&nbsp;&mdash;
                Goldman Sachs.
              </p>
            </div>
          </div>
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              &laquo;Авито&raquo; покупает CheckOut. С&nbsp;помощью этой логистической платформы
              клиенты сервиса получали доступ к&nbsp;40&nbsp;тыс. пунктам выдачи, постаматам
              и&nbsp;отделениям &laquo;Почты России&raquo;.
            </p>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--3">
          <div className="growth-page__wrap-img ">
            <div className="growth-page__img _growth-anim">
              <img
                src="img/two/growth-page-4-2.png"
                srcSet="img/two/growth-page-4-2.png 1x, img/two/growth-page-4-2@2x.png 2x"
                alt="img"
                className="_growth-anim"
              />
            </div>
            <p className="growth-page__caption _growth-anim _growth-anim--fade">Статья на rb.ru</p>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--4">
          <div className="note growth-page__note _growth-anim">
            <p className="note__text _small-text">
              Осенью доля трафика &laquo;Авито&raquo; с&nbsp;мобильных устройств превысила&nbsp;50%,
              в&nbsp;то&nbsp;время как в&nbsp;начале 2014 года на&nbsp;мобильные устройства
              приходились лишь&nbsp;32% трафика.
            </p>
          </div>
          <div className="note growth-page__note">
            <p className="note__text _small-text _growth-anim">
              Платными становятся объявления вакансий для работодателей, размещение больше одного
              объявления о&nbsp;продаже авто за&nbsp;месяц и&nbsp;все объявления по&nbsp;продаже
              квартир.
            </p>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--5">
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              За&nbsp;5&nbsp;лет &laquo;Авито&raquo; увеличила аудиторию почти впятеро
            </p>
            <p className="growth-page__text _small-text _growth-anim">Месячная аудитория*, млн чел.</p>
            <p className="growth-page__text _small-text _growth-anim">
              Позиция в&nbsp;рейтинге самых посещаемых сайтов
            </p>
            <p className="growth-page__text _small-text _growth-anim">
              *Показатель &laquo;Вся Россия&raquo;, TNS Web Index
            </p>
          </div>
          <div className="growth-page__col">
            <div className="growth-page__wrap-img">
              <div className="growth-page__img _growth-anim">
                <img
                  src="img/two/growth-page-4-3.png"
                  srcSet="img/two/growth-page-4-3.png 1x, img/two/growth-page-4-3@2x.png 2x"
                  alt="img"
                  className='_growth-anim'
                />
              </div>
            </div>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--6">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Декабрь</span>
            <span className="growth-page__year">2015</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">
            Поезд &laquo;Симферополь&nbsp;&mdash; Москва&raquo;
          </h2>
        </div>
        <div className="growth-page__row growth-page__row--7">
          <div className="growth-page__col">
            <div className="quote quote--white growth-page__quote _growth-anim">
              <div className="quote__content">
                <p className="quote__text _text">
                  Мы&nbsp;решили задачу с&nbsp;акционерной стоимостью, при этом сохранили гибкость
                  и&nbsp;автономность российского бизнеса. Кроме того, у&nbsp;многих сотрудников
                  появилась возможность общаться, взаимодействовать со&nbsp;своими коллегами
                  в&nbsp;других странах и&nbsp;обмениваться опытом
                </p>
              </div>
              <div className="quote__caption">
                <div className="quote__caption-img">
                  <img
                    src="/img/vladimir.png"
                    srcSet="/img/vladimir.png 1x, /img/vladimir@2x.png 2x"
                    alt="img"
                    className="img"
                  />
                </div>
                <span className="quote__caption-text">Владимир Правдивый</span>
              </div>
            </div>
            <div className="note growth-page__note _growth-anim">
              <p className="note__text _small-text">
                К&nbsp;концу 2015 года ежемесячная аудитория Авито составила
              </p>
              <p className="note__main">30&nbsp;млн человек</p>
            </div>
          </div>
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              В&nbsp;это&nbsp;же время 50&nbsp;человек, работавших в&nbsp;симферопольском офисе
              &laquo;Авито&raquo;, переехали в&nbsp;Москву. Команда поддержки вместе
              с&nbsp;привезенными серверами сначала расположилась в&nbsp;отеле рядом с&nbsp;офисом
              на&nbsp;Лесной, 7.
            </p>
            <p className="growth-page__text _text _growth-anim">
              Naspers выкупает доли остальных акционеров &laquo;Авито&raquo; за&nbsp;$1,2 млрд
              и&nbsp;становится основным владельцем платформы.
            </p>
            <div className="growth-page__wrap-img">
              <div className="growth-page__img _growth-anim">
                <img
                  src="img/two/growth-page-4-4.png"
                  srcSet="img/two/growth-page-4-4.png 1x, img/two/growth-page-4-4@2x.png 2x"
                  alt="img"
                  className='_growth-anim'
                />
              </div>
            </div>
          </div>
        </div>
        <div className="growth-page__footer _footer">
          <div className="growth-page__footer-col">
            <div className="growth-page__footer-date">
            2015
            </div>
          </div>
          <div
            className="growth-page__footer-col"
            onClick={() => setCurrentPage({ status: true, el: 5 })}>
            <div className="growth-page__footer-img">
              <img
                src={`img/two/growth-page-footer-5.png`}
                srcSet={`img/two/growth-page-footer-5.png 1x, img/two/growth-page-footer-5@2x.png 2x`}
                alt="img"
              />
            </div>
            <span className="growth-page__footer-year">
            2016
            </span>
            <h3 className="growth-page__footer-title">
            Масштабные обновления: от доставки до приложения
            </h3>
          </div>
          <div className="growth-page__footer-col">
            <span
              className="growth-page__footer-date"
              onClick={() => setCurrentPage({ status: true, el: 5 })}>
              Далее
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default TwoPage4;
